import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=13017bec&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Copy.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Copy.vue
// module id = 2393
// module chunks = 1